// extracted by mini-css-extract-plugin
export default {"header":"Header_header__hxUrr","header-layout":"Header_header-layout__BB9w1","dates":"Header_dates__9SVik","studio":"Header_studio__iixW9","logo":"Header_logo__ZT12l"};